




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTrombolisisLogDialog from "./MonitoringTrombolisisLogDialog.vue";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    MonitoringTrombolisisLogDialog,
  }
})
export default class MonitoringTrombolisisLogTimeline extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  showLogDialog = false;
  editingLog: any = null;
  prefillWaktu: string | null = null;

  komplikasiForm: any = {};

  logHeaders = [
    { text: "Waktu", value: "waktu", width: "130px" },
    { text: "T+", value: "menit_dari_bolus", width: "60px" },
    { text: "TD (mmHg)", value: "td", width: "90px", sortable: false },
    { text: "Nadi", value: "nadi", width: "55px" },
    { text: "RR", value: "rr", width: "45px" },
    { text: "SpO2", value: "spo2", width: "55px" },
    { text: "NIHSS", value: "nihss_score", width: "55px" },
    { text: "GCS", value: "gcs", width: "50px", sortable: false },
    { text: "Motorik", value: "motorik", width: "70px", sortable: false },
    { text: "Bicara", value: "bicara", width: "70px" },
    { text: "Alert", value: "perdarahan", width: "50px", sortable: false },
    { text: "", value: "actions", sortable: false, width: "70px" },
  ];

  mounted() {
    this.initKomplikasiForm();
  }

  get sortedLogs() {
    return [...(this.monitoring?.logs || [])].sort(
      (a: any, b: any) => a.menit_dari_bolus - b.menit_dari_bolus
    );
  }

  get lastLog() {
    const logs = this.sortedLogs;
    return logs.length > 0 ? logs[logs.length - 1] : null;
  }

  initKomplikasiForm() {
    const m = this.monitoring;
    this.komplikasiForm = {
      komplikasi_ich: m.komplikasi_ich || false,
      komplikasi_ich_at: m.komplikasi_ich_at ? m.komplikasi_ich_at.substring(0, 16) : "",
      komplikasi_perdarahan_lain: m.komplikasi_perdarahan_lain || false,
      komplikasi_perdarahan_text: m.komplikasi_perdarahan_text || "",
      komplikasi_angioedema: m.komplikasi_angioedema || false,
      infus_dihentikan: m.infus_dihentikan || false,
      infus_dihentikan_at: m.infus_dihentikan_at ? m.infus_dihentikan_at.substring(0, 16) : "",
      infus_dihentikan_alasan: m.infus_dihentikan_alasan || "",
    };
  }

  formatDatetime(dt: string) {
    return dt ? moment(dt).format("DD/MM HH:mm") : "-";
  }

  openLogDialog() {
    this.editingLog = null;
    this.prefillWaktu = null;
    this.showLogDialog = true;
  }

  openLogDialogCopyPrevious() {
    // Open dialog with previous log data as prefill
    this.editingLog = { ...this.lastLog, id: undefined };
    this.prefillWaktu = moment().format("YYYY-MM-DDTHH:mm");
    this.showLogDialog = true;
  }

  editLog(log: any) {
    this.editingLog = log;
    this.prefillWaktu = null;
    this.showLogDialog = true;
  }

  async deleteLog(log: any) {
    const q = confirm("Hapus log monitoring ini?");
    if (!q) return;

    try {
      const resp = await MonitoringTrombolisisSvc.deleteLog(this.monitoring.id, log.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Log berhasil dihapus");
        this.$emit("saved", { id: this.monitoring.id });
      }
    } catch { /* */ }
  }

  onLogSaved() {
    this.$emit("saved", { id: this.monitoring.id });
  }

  async saveKomplikasi() {
    try {
      await MonitoringTrombolisisSvc.update(this.monitoring.id, this.komplikasiForm);
      this.$emit("saved", { id: this.monitoring.id });
    } catch { /* */ }
  }
}
